import React from 'react';
import { MultiColorIcon } from '@tt/ui';
import cx from 'classnames';
import { useEmptyState } from '../../context';
import styles from '../../EmptyState.module.scss';
const sizeMap = {
    sm: 'md',
    md: 'xl',
    lg: 'xxl',
};
const Icon = ({ name = 'not-found', className, ...props }) => {
    const { size } = useEmptyState();
    return (React.createElement(MultiColorIcon, { className: cx(styles.icon, className), ...props, name: name, size: sizeMap[size] }));
};
export default Icon;
